module.exports = __webpack_public_path__ + "img/chess-knight-piece.0d630af8.svg";